export default {
  data () {
    return {
      locales: {
        /*'Asia/Tehran': {
          timezone: '+0330',
          locale: 'fa'
        },
        'Asia/Dubai': {
          timezone: '+0400',
          locale: 'en'
        },*/
        /*'Asia/Dubai': {
          timezone: '+0400',
          locale: 'en'
        }*/
      }
    }
  },
  methods: {
    getLocale: function (region) {
      return this.locales[region] ? this.locales[region].locale : 'en'
    },
    getTimezone: function (region) {
      return this.locales[region].timezone
    }
  }
}
